module.exports = __webpack_public_path__ + "static/img/2008.5f84000.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2008.jpg
// module id = 299
// module chunks = 0